import FormController from 'controllers/form-controller';
import { ezErrorDisplay } from 'ez-styles/assets/javascripts/ez-styles/utils/errors';
import { parseErrorMsg, usernameValidation } from 'lib/validation-helpers';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class RegistrationsDetailsFormController extends FormController {
  connect() {
    super.connect();
  }

  validateFields(event) {
    super.validateFields(event);

    this.validateFullName();
    this.validateUsername();

    if (this.formValid) {
      triggerCustomEvent(events.sessions.new_account_created, {
        accountType: 'free',
      });

      this.continueRegistration();
    }
  }

  continueRegistration() {
    if (this.downloadLimitModal) {
      this.element.action = `${this.element.action}?download_limit=true&signup_from_resource_show=true`;
    }

    this.checkNewsletterOption();
    this.submit();
  }

  checkNewsletterOption() {
    const newsletterOption = document.getElementById('newsletter');

    if (newsletterOption && newsletterOption.checked) {
      sessionStorage.setItem('newsletter_preference', 'newsletter_signup');
    } else {
      sessionStorage.setItem('newsletter_preference', 'no_newsletter_signup');
    }
  }

  validateFullName() {
    const fullNameField = document.getElementById('user_full_name');
    const fullNameRegex = new RegExp("^[a-zA-Z]([-']?[a-zA-Z]+)*[.]?( [a-zA-Z]([-']?[a-zA-Z]+[.]?)*[.]?)+$");
    const fullNameFieldVal = fullNameField.value.trim().replace(/ +(?= )/g, '');

    if (
      fullNameField
      && fullNameFieldVal
      && !fullNameFieldVal.match(fullNameRegex)
    ) {
      ezErrorDisplay(fullNameField, parseErrorMsg(fullNameField, 'include_full_name'));
      this.formValid = false;
    }
  }

  validateUsername() {
    const usernameField = document.getElementById('user_username');

    if (usernameField && usernameField.value) {
      const userNameValidity = usernameValidation(usernameField.value);

      if (userNameValidity !== true) {
        ezErrorDisplay(usernameField, parseErrorMsg(usernameField, userNameValidity));
        this.formValid = false;
      }
    }
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('from-dl-limit-modal');
  }
}
